import type { FunctionComponent } from 'react';

import { SkeletonBase } from '~/ui/core/skeleton/Skeleton';
import { TableBody, TableCell, TableContainer, TableGrid, TableRow } from '~/ui/core/table/Table';

import { useAuditTableLabels } from '../use-audit-table-labels';
import { AuditDisplayShell } from './AuditDisplayShell';
import { ACTION_BAR_AUDIT_COLUMN_WIDTHS, ACTION_BAR_LINE_WRAPPER_CLASS } from './constants';

const CELL_BASE_CLASS =
    'flex items-center text-gray-800 text-xxs transition-colors duration-200 ease-in-out !min-h-[34px] !min-w-0 !py-xs !px-[calc(var(--spacing-s)+var(--spacing-m)-var(--spacing-xxs))]';

export const AuditTableSkeleton: FunctionComponent = () => {
    const labels = useAuditTableLabels('draft');

    return (
        <AuditDisplayShell footerAction={null}>
            <TableContainer $inset="compact" className="!h-auto !rounded-none !bg-transparent">
                <TableGrid
                    $horizontalScroll={false}
                    aria-label={labels.ariaLabel}
                    className="!overflow-visible !rounded-none"
                    role="grid"
                >
                    <TableBody className="!overflow-visible">
                        <TableRow
                            $animateLayout={false}
                            $columnWidths={ACTION_BAR_AUDIT_COLUMN_WIDTHS}
                            $size="small"
                            className="group"
                        >
                            <TableCell $size="small" className={`${CELL_BASE_CLASS} !justify-start`} role="gridcell">
                                <span className={ACTION_BAR_LINE_WRAPPER_CLASS}>
                                    <span className="flex min-w-0 items-center gap-xs overflow-hidden">
                                        <SkeletonBase className="h-[14px] w-[14px] shrink-0 rounded-full" />
                                        <SkeletonBase className="h-l w-[72px] shrink-0" />
                                        <SkeletonBase className="h-l w-[12px] shrink-0" />
                                        <SkeletonBase className="h-l w-[112px] min-w-0" />
                                    </span>
                                </span>
                            </TableCell>
                            <TableCell $size="small" className={`${CELL_BASE_CLASS} !justify-end`} role="gridcell">
                                <span className="flex shrink-0 items-center gap-xs">
                                    <SkeletonBase className="h-[24px] w-[76px] rounded-full" />
                                    <SkeletonBase className="h-l w-l rounded-full" />
                                </span>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </TableGrid>
            </TableContainer>
        </AuditDisplayShell>
    );
};
